import React, {useCallback, useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import UrsHeader from "../components/UrsHeader";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {input, news, sip} from "../translate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDownWideShort, faArrowUpShortWide, faPenToSquare, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import TableBody from "@mui/material/TableBody";
import TableLoader from "../components/TableLoader";
import {Link, useLocation, useNavigate} from "react-router-dom";
import BlockIcon from '@mui/icons-material/Block';
import Api from "../Api";
import {useSelector} from "react-redux";
import SendIcon from '@mui/icons-material/Send';
import UrsMessageBlock from "../components/UrsMessageBlock";
import {toast} from "react-toastify";
import moment from "moment";

const {REACT_APP_SERVER} = process.env;


function UrsInBlock(props) {
    const [message, setMessage] = useState('Հարգելի բաժանորդ!\n Տեղեկացնում ենք որ Ձեր զանգերի կենտրոնի համակարգի ծառայությունը վաղը կկասեցվի ՝ գումարը չվճարելու պատճառով։')
    const [open, setOpen] = useState('')
    const [who, setWho] = useState('')
    const [newsList, setNewsList] = useState([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const profile = useSelector(state => state.users.ursData)

    useEffect(() => {
        (async () => {
            setLoading(true)
            const {data} = await Api.inBasketGet();
            setNewsList(data.members)
            setLoading(false)
        })()
    }, [])


    const handleDelete = async (id) => {
        setLoading(true)
        await Api.inBasket(id, 0)
        setNewsList(prev => prev.filter((item) => item.id !== id))
        setLoading(false)
    }

    const handleBlock = useCallback(async (id) => {
        try {
            let text = +localStorage.getItem('atsLang') === 1 ? "Are you sure you want to change status?" :
                +localStorage.getItem('atsLang') === 2 ? "Вы уверены, что хотите изменить?" :
                    "Վստա՞հ եք, որ ցանկանում եք փոփոխել տողը";

            if (confirm(text) === true) {
                try {
                    setLoading(true)
                    for (const idElement of newsList) {
                        if (+idElement.id === +id) {
                            await Api.blocked(id, 1)
                        }
                    }
                    setNewsList((prevData) => prevData.filter((item) => item.id !== id))
                    setLoading(false)
                } catch (e) {
                    toast.error(e.response.data.message)
                }

            }
        } catch (e) {
            console.log(e)
        }
    }, [newsList])

    return (
        <>

            <Helmet>
                <title>Admin Panel</title>
            </Helmet>
            <UrsHeader/>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: 20,}}>
                <div className="tableParent" id="tableParent">
                    <Paper
                        style={{width: window.innerWidth <= 1024 ? '100%' : 1024,}}
                        sx={{minWidth: 'fit-content', fontSize: 10, width: window.innerWidth <= 1024 ? '100%' : 1024,}}>
                        <TableContainer
                        >
                            <Table className={loading ? "myTableStyle" : ''} stickyHeader
                                   aria-label="sticky table">
                                <TableHead>
                                    <TableRow className="sip_header">
                                        <TableCell sx={{fontSize: 20,}} align="left" colSpan={3}>
                                            To Block
                                        </TableCell>
                                        <TableCell sx={{fontSize: 15, padding: '0 35px', height: 50}} align="right"
                                        >
                                            <span className="d-flex justify-content-end align-items-center">

                                            </span>
                                            <span className="add">

                                            </span>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow
                                        className="sip_num">
                                        <TableCell
                                            className="action"
                                            align='center'
                                        >
                                            Անուն
                                        </TableCell>
                                        <TableCell
                                            className="action"
                                            align='center'
                                        >
                                            Համար
                                        </TableCell>  <TableCell
                                            className="action"
                                            align='center'
                                        >
                                            Վերջին հաղորդագրության ամսաթիվը
                                        </TableCell> <TableCell
                                        className="action"
                                        align='center'
                                    >
                                        {sip.action[+localStorage.getItem('atsLang') || 1]}
                                    </TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody id="dataBody">

                                    {loading ? <TableLoader colSpan={4}/> : newsList.length ? newsList.map((s, _) => (
                                        <TableRow
                                            style={s.message_send && moment(s.send_date).isSame(moment(), 'month')?{backgroundColor: '#94ffac'}:{}}
                                            key={_} hover role="checkbox" tabIndex={-1}>

                                            <TableCell className="action" align="center">
                                                {s.fio}
                                            </TableCell>
                                            <TableCell className="action" align="center">
                                                {s.name}
                                            </TableCell>
                                            <TableCell className="action" align="center">
                                                {moment.utc(s.send_date).format('DD-MM-YYYY HH:mm:ss')}

                                            </TableCell>
                                            <TableCell className="action" align="center">
                                                <p style={{
                                                    fontSize: 13,
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'center'
                                                }}> <span onClick={() => {
                                                    setOpen(s.id)
                                                    setWho(s.id)
                                                }} className="edit">
                                                    <SendIcon
                                                    /></span>

                                                    <span onClick={() => handleBlock(s.id)}
                                                          className="delete">
                                                        <BlockIcon/>
                                                    </span>

                                                    <span onClick={() => handleDelete(s.id)}
                                                          className="delete"><FontAwesomeIcon
                                                        icon={faTrashCan}/></span>

                                                </p>
                                            </TableCell>

                                        </TableRow>

                                    )) : <TableRow hover role="checkbox" tabIndex={-1}>


                                        <TableCell align="center" colSpan={4}>
                                            no data

                                        </TableCell>


                                    </TableRow>
                                    }


                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div style={{padding: 10}}
                             className="foot_footer d-flex align-items-center justify-content-end">
                            <span
                                onClick={() => {
                                    setOpen('array');
                                    setWho('array')
                                }}
                                style={{margin: '0 10px'}}
                                className="addBtn"
                            >
                                Ուղարկել հաղորդագրություն բոլորին
                            </span>
                        </div>
                    </Paper>
                    <UrsMessageBlock setList={setNewsList} setWho={setWho} who={who} list={newsList} message={message} setOpen={setOpen} open={open}
                                     setMessage={setMessage}/>
                </div>
            </div>
        </>
    );
}

export default UrsInBlock;